import React, { useEffect } from 'react'
import './access.css'
import logo from "../../assets/Aspom-Logo.png"
import lockIcon from '../../assets/lock.png'
import { useNavigate } from "react-router-dom";

const Access = () => {
    const navigate = useNavigate()
      // Fetch user's IP address
    const fetchIPAddress = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            const ipAddress = data.ip;
            // Send IP address to backend
            sendIPAddressToBackend(ipAddress);
        } catch (error) {
            console.error('Error fetching IP address:', error);
        }
    };
    
    // Send user's IP address to backend
    const sendIPAddressToBackend = async (ipAddress) => {
        try {
            // const response = await fetch('https://backend.aspomportal.com/access-location', {
            const response = await fetch('https://aspom-server.onrender.com/access-location', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ipAddress }),
            });
            const data = await response.json();
            if(data?.access){
                navigate('/auth')
                window.location.replace('/auth')
                localStorage.removeItem('access')
            }
        } catch (error) {
            console.error('Error sending IP address to backend:', error);
        }
    };
  
    // Call fetchIPAddress when the component mounts
    useEffect(() => {
        fetchIPAddress();
    }, []);
    

    const handleClick = () =>{
        window.location.replace('/auth')
        fetchIPAddress()
    }

  return (
    <section className='forgot__page'>
        <div className="forgot__container">
            <div className="forgot__content-heading">
                <div className="forgot__content-text">
                    <h1 className="forgot__form-title">
                        Access Denied
                    </h1>
                    <span className="forgot__form-subtitle">
                        Wait a while, we are bringing the office to your current location.
                    </span>
                </div>
                <img src={logo} alt="" className="forgot__content-logo" />
            </div>
            <div className="access__content">
                <img src={lockIcon} alt="" className="access__img" />
                <div className="access__items">
                    <p className="access__message">
                        Oops! Looks like you're trying to access the dashboard from a mysterious location.
                        🚀 Don't worry, we've got your back! Please teleport yourself back to
                        the designated work place, where the magic happens, and refresh your browser.
                    </p>
                    <button onClick={handleClick}
                    className="button">Refresh</button>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Access